module.exports = __webpack_public_path__ + "static/media/proj1_img11.822f6beb.jpg";